import React from 'react';

const styles = {
  container: {
    
  },
  page: {
    border: '1px solid black',
    padding: '20px',
    marginBottom: '20px',
  },
  h1: {
    textAlign: 'center',
    color: '#333',
    paddingBottom: '10px',
    marginBottom: '20px',
  },
  h2: {
    textAlign: 'left',
    color: '#555',
    paddingBottom: '5px',
    marginTop: '30px',
  },
  notice: {
    fontWeight: 'bold',
    fontSize: '17px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
    marginBottom: '20px',
  },
  th: {
    textAlign: 'center',
    border: '1px solid #ddd',
    padding: '8px',
    backgroundColor: '#f2f2f2',
  },
  td: {
    textAlign: 'left',
    border: '1px solid #ddd',
    padding: '8px',
  },
  tdRight: {
    textAlign: 'right',
    border: '1px solid #ddd',
    padding: '8px',
  },
  ul: {
    textAlign: "left",
    margin: "0",
    paddingLeft: '20px',
  },
  footer: {
    textAlign: 'right',
    marginTop: '20px',
    fontSize: '1.3em',
  },
  note: {
    fontSize: '15px',
    color: '#555',
  },
  kojinjohoContainer: {
    border: "1px solid black",
    borderRadius: "20px",
    padding: "3%"
  },
  kojinjohoMokuteki: {
    fontSize: "1.5em",
    border: "1px solid #ddd",
    borderRadius: "20px",
    backgroundColor: "#ddd",
    padding: "0.2rem 0"
  },
  h3: {
    textAlign: "left",
    fontSize: "1em",
    marginBottom: "0"
  },
  hukiContainer: {
    marginTop: "1em",
    display: "flex",
  },
  huki: {
    fontSize: "0.8em",
    writingMode: "vertical-rl",
    border: "1px solid black",
    display: "inline-flex",
    justifyContent: "center",
    padding: "0 0.2rem"
  },
  paperArea: {
    border: "1px solid black",
    padding: "3%"
  }
};

const Yoyaku = () => {
  const AboutYoyaku = [
  "ご予約の方の診療を優先とさせていただきます。ご予約のない方はご予約の方の診療のあとになりますので、受付の順番と前後する場合があります。",
  "各種健康診断や予防接種等は完全ご予約制とさせていただいております。",
  "急患の方や重症の方がご来院された場合は、ご予約をいただいた方よりも優先させていただくことがありますのでご了承ください。",
  "診療の混雑状況によっては、ご予約時間を過ぎてしまう場合があります。"
];

// ご予約の申し込みについて
const AboutMoshikomi = [
  "ご予約はお電話か窓口でお申し込みください。",
  {
    title: "ご予約受付時間は、原則、月~金曜日(休診日を除く)の午後1:00~3:00とさせていただきます。",
    caution: " ※診療時間中のご予約お申込みについては、診療の混雑状況によって、ご予約受付時間内に改めてお願いする場合があります。"
  },
  {
    title: "ご予約のお申し込みは前日までとさせていただきます。",
    caution: "※ご来院当日のご予約はお受けできませんので、受付時間中にご来院いただき順番が来るまでお待ちください。"
  },
  "健康診断等で医療機関受診や要精密検査等の指摘があった方は、健康診断等の結果票を事前にご持参の上、診療のご予約をお申し込みください。",
  "転居等で当院に転院をご希望の方は、前医からの診療情報提供書を事前にご持参の上、診療のご予約をお申し込みください。"
];

  const YoyakuStyles = {
    h1: {
      
    },
    ulContainer: {
      width: "80%",
      margin: "auto"
    },
    li: {
      marginBottom: "1rem",
      fontSize: "20px"
    },
    p: {
      fontSize: "20px",
    },
    caution: {
      margin: "0 0 1rem 1.2rem",
    }
  }

  return (
<div style={styles.page}>
      <h1 style={styles.h1}>【診療予約について】</h1>
      <p style={YoyakuStyles.p}>当院では、診療を原則ご予約制とさせていただいております。</p>
      <ul className="noListMarker" style={{...styles.ul, ...YoyakuStyles.ulContainer}}>
        {
          AboutYoyaku.map((list, index) => {
            return (
              <li className="listTriangle" key={index} style={YoyakuStyles.li}>{list}</li>
            )
          })
        }
      </ul>

      <h1 style={styles.h1}>【ご予約のお申込みについて】</h1>
      <ul className="noListMarker" style={{...styles.ul, ...YoyakuStyles.ulContainer}}>
        {
          AboutMoshikomi.map((list, index) => {
            if(list.title){
              return (
                <>
                  <li className="listTriangle" key={index} style={YoyakuStyles.li}>{list.title}
                    <p style={YoyakuStyles.caution}>{list.caution}</p>
                  </li>
                </>
              )
            }
            return (
              <li className="listTriangle" key={index} style={YoyakuStyles.li}>{list}</li>
            )
          })
        }
      </ul>

    </div>
  )
}

// ページ2: 保険外費用について
const HokengaiHiyo = () => {
  const documentCreationCosts = [
    { name: "診断書(標準)", price: "3,000円~", remarks: "作成のための検査費用は別料金" },
    { name: "診断書(特別)", price: "5,000円~", remarks: "死亡診断書/胸部X線検査が必要な場合" },
    { name: "領収証明書", price: "1,500円", remarks: "" },
    { name: "通院証明書", price: "5,000円", remarks: "" },
    { name: "カルテの開示手数料", price: "10,000円~", remarks: ["面談費用:5,000円/回~", "開示手数料は所要時間1日につき10,000円"] },
  ]; // 出典: （ホームページ掲載用）院内掲示.pdf P1

  const examinationCosts = [
    { name: "血液型", price: "2,000円", remarks: "ABO式・Rh(D)式を実施" },
    { name: "妊娠反応", price: "2,000円", remarks: "" },
    { name: "HIV", price: "5,000円~", remarks: "1項目5,000円　2項目10,000円" },
    { name: "ペプシノゲン", price: "4,000円", remarks: "" },
    { name: "その他", price: "", remarks: "診療報酬上の各検査の費用によって設定" },
  ]; // 出典: （ホームページ掲載用）院内掲示.pdf P1

  const vaccinationCosts = [
    { name: "水痘", price: "6,000円", remarks: "" },
    { name: "日本脳炎", price: "4,500円", remarks: "" },
    { name: "おたふく", price: "4,000円", remarks: "" },
    { name: "破傷風", price: "3,500円", remarks: "" },
    { name: "肺炎球菌", price: "8,000円", remarks: "高齢者助成制度あり" },
    { name: "肝炎", price: "4,000円", remarks: "1回につき(通常3回接種)" },
    { name: "麻疹・風疹(混合ワクチン)", price: "10,000円", remarks: "" },
    { name: "破傷風・ジフテリア(混合ワクチン)", price: "3,500円", remarks: "" },
    { name: "破傷風・ジフテリア・百日咳(混合ワクチン)", price: "3,500円", remarks: "" },
    { name: "インフルエンザ", price: "4,800円", remarks: "高齢者助成制度あり" },
    { name: "新型コロナワクチン", price: "18,000円", remarks: "高齢者助成制度あり" },
    { name: "帯状疱疹(生ワクチン)", price: "8,000円", remarks: "助成制度あり" },
    { name: "帯状疱疹(シングリックス)", price: "21,000円", remarks: "1回につき(通常2回接種)" },
  ]; // 出典: （ホームページ掲載用）院内掲示.pdf P1

  const renderRemarks = (remarks) => {
    if (Array.isArray(remarks)) {
      return remarks.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < remarks.length - 1 && <br />} 
        </React.Fragment>
      ));
    }
    return remarks;
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.h1}>保険外費用について</h1>
      <p style={styles.notice}>当院では、健康保険の療養に該当しない保険外費用について実費のご負担をお願いしています。</p>

      <h2 style={styles.h2}>1, 文書作成費用(税別)</h2>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>文書名等</th>
            <th style={styles.th}>料金</th>
            <th style={styles.th}>備考</th>
          </tr>
        </thead>
        <tbody>
          {documentCreationCosts.map((item, index) => (
            <tr key={index}>
              <td style={styles.td}>{item.name}</td>
              <td style={styles.td}>{item.price}</td>
              <td style={styles.td}>{renderRemarks(item.remarks)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 style={styles.h2}>
        2. 検査(税込)
        <span style={styles.note}>＊診療報酬改定等により変動あり</span>
      </h2>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>検査内容</th>
            <th style={styles.th}>料金</th>
            <th style={styles.th}>備考</th>
          </tr>
        </thead>
        <tbody>
          {examinationCosts.map((item, index) => (
            <tr key={index}>
              <td style={styles.td}>{item.name}</td>
              <td style={styles.td}>{item.price}</td>
              <td style={styles.td}>{item.remarks}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 style={styles.h2}>
        3. 予防接種(税込)
        <span style={styles.note}>＊ワクチン購入価格により変動あり</span>
      </h2>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>ワクチンの種類</th>
            <th style={styles.th}>一般料金</th>
            <th style={styles.th}>備考</th>
          </tr>
        </thead>
        <tbody>
          {vaccinationCosts.map((item, index) => (
            <tr key={index}>
              <td style={styles.td}>{item.name}</td>
              <td style={styles.tdRight}>{item.price}</td>
              <td style={styles.td}>{item.remarks}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// ページ3: 個人情報保護について
const KojinJohoHogo = () => {
  return (
    <div style={styles.page}>
      <h1 style={styles.h1}>当院は患者さんの個人情報保護に全力で取り組んでいます</h1>
      <p>当院は、個人情報を下記の目的に利用し、その取り扱いには細心の注意を払っています。個人情報の取り扱いについてお気づきの点は、窓口までお気軽にお申し出ください。</p>

    <div style={styles.kojinjohoContainer}>
      <div style={styles.kojinjohoMokuteki}>
        当院における個人情報の利用目的
      </div>

      <h3 style={styles.h3}>● 医療提供</h3>
      <ul className="noListMarker" style={styles.ul}>
        <li className="listTriangle">当院での医療サービスの提供</li>
        <li className="listTriangle">他の病院、診療所、助産所、薬局、訪問看護ステーション、介護サービス事業者等との連携</li>
        <li className="listTriangle">他の医療機関等からの照会への回答</li>
        <li className="listTriangle">患者さんの診療のため、外部の医師等の意見・助言を求める場合</li> 
        <li className="listTriangle">検体検査業務の委託その他の業務委託</li> 
        <li className="listTriangle">ご家族等への病状説明</li> 
        <li className="listTriangle">その他、患者さんへの医療提供に関する利用</li> 
      </ul>

      <h3 style={styles.h3}>● 診療費請求のための事務</h3>
      <ul className="noListMarker" style={styles.ul}>
        <li className="listTriangle">当院での医療・介護・労災保険、公費負担医療に関する事務およびその委託</li> 
        <li className="listTriangle">審査支払機関へのレセプトの提出</li> 
        <li className="listTriangle">審査支払機関又は保険者からの照会への回答</li> 
        <li className="listTriangle">公費負担医療に関する行政機関等へのレセプトの提出、照会への回答</li> 
        <li className="listTriangle">その他、医療・介護・労災保険、および公費負担医療に関する診療費請求のための利用</li> 
      </ul>

      <h3 style={styles.h3}>● 当院の管理運営業務</h3>
      <ul className="noListMarker" style={styles.ul}>
        <li className="listTriangle">会計・経理</li> 
        <li className="listTriangle">医療事故等の報告</li> 
        <li className="listTriangle">当該患者さんの医療サービスの向上</li> 
        <li className="listTriangle">入退院等の病棟管理</li> 
        <li className="listTriangle">その他、当院の管理運営業務に関する利用</li> 
      </ul>

      <h3 style={styles.h3}>● 企業等から委託を受けて行う健康診断等における、企業等へのその結果の通知</h3> 
      <h3 style={styles.h3}>● 医師賠償責任保険などに係る、医療に関する専門の団体、保険会社等への相談又は届出等</h3> 
      <h3 style={styles.h3}>● 医療・介護サービスや業務の維持・改善のための基礎資料</h3> 
      <h3 style={styles.h3}>● 当院内において行われる医療実習への協力</h3> 
      <h3 style={styles.h3}>● 医療の質の向上を目的とした当院内での症例研究</h3> 
      <h3 style={styles.h3}>● 外部監査機関への情報提供</h3> 
    </div>


    <div style={styles.hukiContainer}>
      <div style={styles.huki}>付記</div>
      <ol style={{ fontSize: '0.7rem', textAlign: "left", paddingInlineStart: "1.1rem", margin: "0" }}>
        <li>上記のうち、他の医療機関等への情報提供について同意しがたい事項がある場合には、その旨をお申し出ください。</li> 
        <li>お申し出がないものについては、同意していただけたものとして取り扱わせていただきます。</li> 
        <li>これらのお申し出は後からいつでも撤回、変更等をすることが可能です。</li> 
      </ol>
    </div>

      <div style={{...styles.footer, border: "1px solid black", borderRadius: "1rem", padding: "1rem"}}>
        中町内科医院
      </div>
    </div>
  );
};

// ページ3: 明細書発行体制等加算
// const Page3MeisaishoHakko = () => {
//   return (
//     <div style={styles.page}>
//       <h2 style={styles.h2}>【明細書発行体制等加算】</h2> 
//       <h2 style={{...styles.h2, borderBottom: 'none', textAlign: "center"}}>「個別の診療報酬の算定項目の分かる明細書」発行について</h2> 
//       <div style={{padding: "0 1rem", textAlign: "left"}}>
//         <p>　当院では、医療の透明化や患者様の情報提供を推進していく観点から、原則として個別の診療報酬の内訳の分かる明細書を無料で発行しています。</p> 
//         <p>　明細書は保険点数として明記され、保険点数に10円を乗じた金額が診療費となります。</p> 
//         <p>　これらの点を理解いただいた上で、希望されない方は受付までお申し出ください。</p> 
//       </div>
//       <div style={styles.footer}>中町内科医院院長</div> 
//     </div>
//   );
// };

// ページ4: 外来感染対策向上加算
const GairaiKansenTaisaku = () => {
  return (
    <div style={styles.page}>
      <h2 style={{...styles.h2, marginBottom: "0"}}>【外来感染対策向上加算】</h2> 
      <h2 style={{...styles.h2, padding: "0 1rem", marginTop: "0", fontSize: "1.2em",lineHeight: "2rem"}}>当院は都道府県知事の指定を受けている第二種協定指定医療機関または医療措置協定に基づく措置を講ずる医療機関です。当院では受診歴の有無に関わらず、発熱およびその他の感染症を疑わせるような症状を呈する患者様の受入れを行っています。</h2> 
      <div style={styles.paperArea}>
        <h2 style={{...styles.h2, textAlign: "center"}}>院内感染防止対策に関する当院の取り組み</h2>
        <ul style={{...styles.ul, fontSize: "1.2em"}}>
          <li>院内感染の防止に留意し、感染等が発生した際には原因の速やかな特定、制圧、終息を図ることが医療を提供する上で大切です。</li> 
          <li>当院では院長の管理のもと、全従業員が「標準予防策」を基本とした院内感染防止・対策に努めています。</li> 
          <li>毎日、職員に対して、健康管理を徹底しています。</li> 
          <li>業務中はサージカルマスクの着用、衛生管理を適切に実施しています。</li> 
          <li>感染予防策として遮蔽物の設置、一定の距離の確保、共用部分、共有物等の消毒、換気等を適時、適切に実施しています。</li> 
          <li>発熱がある方を診察する場合には、空間的に動線を分けるなどの対策を講じています。</li> 
          <li>薬剤耐性菌の発生防止のために不必要な抗菌薬の使用を控え、効果的な抗菌薬を選択し、適切な期間処方しています。</li> 
          <li>当院は地域の病院や医師会と連携して院内感染対策に取り組んでいます。</li> 
        </ul>
        <div style={styles.footer}>中町内科医院</div> 
      </div>
    </div>
  );
};

// ページ5: 一般名処方加算
const IppanmeiShoho = () => {
  return (
    <div style={styles.page}>
      <h2 style={styles.h2}>【一般名処方加算】</h2> 
      <h2 style={{...styles.h2, padding: "0 1rem", marginTop: "0", fontSize: "1.2em",lineHeight: "2rem"}}>　当院では後発医薬品の使用促進を図るとともに、医薬品の安定供給に向けた取り組みなどを実施しています。</h2> 
      <h2 style={{...styles.h2, padding: "0 1rem", marginTop: "0", fontSize: "1.2em",lineHeight: "2rem"}}>　後発医薬品のある医薬品について、特定の医薬品名を指定するのではなく、薬剤の成分を基にした一般名処方(一般的な名称により処方箋を発行すること)を行う場合があります。</h2> 


      <div style={{...styles.paperArea, textAlign: "left"}}>
        <div style={{padding: "0 1rem"}}>
          <h3 style={styles.h3}>&lt;後発医薬品のある先発医薬品(長期収載品)の選定療養について&gt;</h3> 
          <p>令和6年10月から後発医薬品(ジェネリック医薬品)があるお薬で、先発医薬品の処方を希望される場合は、<span style={{borderBottom: "2px solid black", fontWeight: "bold" }}>＊特別の料金</span>をお支払いいただきます。</p> 
      </div>
                
        <h3 style={{ ...styles.h2, fontSize: '1.1em', marginTop: '15px', marginBottom: "0"}}><span><span style={{borderBottom: "2px solid black" }}>＊特別の料金</span>とは･･･</span></h3> 
        <p style={{marginTop: "0.5rem", marginBottom: "0"}}>先発医薬品と後発医薬品の価格差の4分の1相当の料金のことを言います。</p> 
        <p style={{marginTop: "0.5rem", marginBottom: "0"}}>例えば、先発医薬品の価格が1錠100円、後発医薬品の価格が1錠、60円の場合、差額40円の4分の1である10円を、通常の1~3割の患者負担とは別に特別の料金としてお支払いいただきます。</p> 
        
        <ul style={{...styles.ul, marginTop: '10px'}}>
          <li>「特別の料金」は課税対象であるため、消費税分を加えてお支払いいただきます。</li> 
          <li>端数処理の関係などで特別の料金が4分の1ちょうどにならない場合もあります</li> 
          <li>後発医薬品がいくつか存在する場合は、薬価が一番高い後発医薬品との価格差で計算します。</li> 
          <li>先発医薬品を処方・調剤する医療上の必要があると認められる場合等は、特別の料金は要りません。</li> 
          <li>薬剤料以外の費用(診療・調剤の費用)はこれまでと変わりません。</li> 
        </ul>
        </div>
    </div>
  );
};

const DensitekiShinryo = () => {
  return (
    <div style={styles.page}>
      <h2 style={{...styles.h2, marginBottom: "0"}}>【電子的診療情報連携体制整備加算】</h2> 
      <h2 style={{...styles.h2, padding: "0 1rem", marginTop: "0", fontSize: "1.2em",lineHeight: "2rem"}}>当院では、医療DX推進体制整備について以下の通り対応を行っています。</h2> 
      <div style={styles.paperArea}>
        <ul style={{...styles.ul, fontSize: "1.2em"}}>
          <li>オンライン請求を行っています。</li> 
          <li>オンライン資格確認を行う体制を有しています。</li> 
          <li>オンライン資格確認を利用して取得した診療情報を、診療室で閲覧又は活用できる体制を有しています。</li> 
          <li>マイナンバーカードの健康保険証利用について、お声掛け、ポスター掲示を行っています。</li> 
          <li>医療DX推進の体制に関する事項および質の高い医療を実施するための十分な情報を取得・活用して診療を行うことについて、当医療機関の見やすい場所およびホームページに掲載しています。</li> 
        </ul>
        <div style={styles.footer}>中町内科医院</div> 
      </div>
    </div>
  );
};


// Appコンポーネント
const Notice = () => {
  return (
    <div className="main-wrapper" id="main-wrapper" style={styles.container}>
      <div className="content-container">
        <Yoyaku />
        <HokengaiHiyo />
        <KojinJohoHogo />
        <GairaiKansenTaisaku />
        <IppanmeiShoho />
        <DensitekiShinryo />
      </div>
    </div>
  );
};

export default Notice;
